import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import { sessionService } from '../../services/SessionService';
import { formatRelative } from "date-fns";
import { es } from "date-fns/locale";

interface ViewInventoryProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class ViewInventory extends React.Component<ViewInventoryProps> {
    @observable private inventory: any;
    @observable private isLoaded = false;
    @observable private id: number = 0;
    @observable private quantity: string = "0";
    @observable private items: any[] = [];
    @observable private locationOptions: any = [
        { name: "Almacen", value: "WAREHOUSE" },
        { name: "Antena", value: "ANTENNA" },
        { name: "Contrato", value: "CONTRACT" }
    ];
    @observable private editingLocationId: { [key: string]: string } = {};

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const match = this.props.match;
        const id = (match as any).params.id;
        this.id = id;
        http.get(`/api/inventory/read/${id}`).then((response) => {
            this.inventory = response.data;
            return this.fetchItems();
        })
            .catch(() => {
                toast.error("Error al cargar el inventario");
            })
            .finally(() => {
                this.isLoaded = true;
            });
    }

    fetchItems = () => {
        return http.get(`/api/inventory/items/${this.id}`).then((response) => {
            this.items = response.data.response || [];
        }).catch(() => {
            toast.error("Error al cargar los ítems");
        });
    }

    private handleChange = (event: any) => {
        this.quantity = event.target.value;
    }

    private enterPressed = (event: any) => {
        let code = event.keyCode || event.which;
        if (code === 13) {
            const code = event.target.value;
            if (!isNaN(Number(code)) && Number.isInteger(Number(code)) && code > 0) {
                this.quantity = code;
                http.post(`/api/inventory/create_item`, JSON.stringify({ inventory_id: this.id, quantity: this.quantity, created_by: sessionService.getUserInfo().id }))
                    .then(() => {
                        toast.success("Inventario agregado");
                        this.fetchItems();
                    })
                    .catch(() => {
                        toast.error("Error agregando inventario");
                    });
            } else {
                toast.error("Cantidad inválida, debe ser un número entero mayor a 0");
                this.quantity = "";
            }
        }
    }

    private deleteItem = (item_id: any): void => {
        http.post(`/api/inventory/delete_item`, JSON.stringify({ id: item_id }))
            .then(() => {
                toast.success("Ítem eliminado");
                this.fetchItems();
            })
            .catch(() => {
                toast.error("Error eliminando ítem");
            });
    }

    private handleLocationChange = (item: any, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newLocationType = event.target.value;
        item.location_type = newLocationType;

        if (newLocationType === "WAREHOUSE") {
            this.updateItemLocation(item, newLocationType, null);
        } else {
            this.editingLocationId[item.id] = item.location_id || "";
        }
    }

    private handleLocationIdChange = (itemId: string, value: string) => {
        this.editingLocationId[itemId] = value;
    }

    private handleLocationIdSubmit = (item: any, event: any) => {
        if (event.keyCode === 13) {
            const locationId = this.editingLocationId[item.id];
            if (!locationId) {
                toast.error("Por favor ingrese un ID");
                return;
            }

            const endpoint = item.location_type === "ANTENNA" ? `/api/antenna/verify/${locationId}` : `/api/contract/verify/${locationId}`;
            
            http.get(endpoint)
                .then((response) => {
                    if (response.data.exists) {
                        this.updateItemLocation(item, item.location_type, locationId);
                        delete this.editingLocationId[item.id];
                    } else {
                        toast.error(`El ${item.location_type === "ANTENNA" ? "antena" : "contrato"} no existe`);
                    }
                })
                .catch(() => {
                    toast.error("Error al verificar el ID");
                });
        }
    }

    private updateItemLocation = (item: any, locationType: string, locationId: string | null) => {
        http.post(`/api/inventory/update_item`, JSON.stringify({
            id: item.id,
            location_type: locationType,
            location_id: locationId,
        }))
            .then(() => {
                toast.success("Ubicación del ítem actualizada");
                this.fetchItems();
            })
            .catch((error) => {
                toast.error("Error al actualizar la ubicación del ítem");
                console.error("Update failed:", error);
                this.fetchItems();
            });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }

        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">
                                        Inventario: {this.inventory.name}
                                    </h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-8"></div>
                                    <div className="col-sm-2">
                                        <Link to={`../../inventario/editar/${this.id}`}>
                                            <button className="btn btn-success btn-sm  pull-right">
                                                <i className="material-icons">edit</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                    <div className="col-sm-2">
                                        <Link to={`../../inventario`}>
                                            <button className="btn btn-danger btn-sm  pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Nombre</label>
                                    <div className="col-sm-8">
                                        <strong>{this.inventory.name}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Creado el</label>
                                    <div className="col-sm-8">
                                        <strong>{this.inventory.created_date}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Creado por</label>
                                    <div className="col-sm-8">
                                        <strong>{this.inventory.created_by_name}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Agregar inventario</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group bmd-form-group is-filled">
                                            <input
                                                type="text"
                                                name="quantity"
                                                autoComplete="off"
                                                placeholder="Agregar cantidad de inventario"
                                                onChange={this.handleChange}
                                                className="form-control"
                                                value={this.quantity}
                                                onKeyPress={this.enterPressed}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Ítems del Inventario</h4>
                                </div>
                            </div>
                            <div className="card-body">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Ubicacion</th>
                                            <th>Id</th>
                                            <th>Creado por</th>
                                            <th>Fecha de creación</th>
                                            <th>Fecha de modificación</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.items.map((item: any) => (
                                            <tr key={item.item_id}>
                                                <td>
                                                    <div className="form-group bmd-form-group">
                                                        <select
                                                            name="location_type"
                                                            onChange={(event) => this.handleLocationChange(item, event)}
                                                            value={item.location_type}
                                                            className="form-control custom-select"
                                                        >
                                                            {this.locationOptions.map((option: any, index: any) => (
                                                                <option value={option.value} key={index}>
                                                                    {option.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </td>
                                                <td>
                                                    {item.location_type === "ANTENNA" || item.location_type === "CONTRACT" ? (
                                                        this.editingLocationId[item.id] !== undefined ? (
                                                            <input
                                                                type="text"
                                                                value={this.editingLocationId[item.id]}
                                                                onChange={(e) => this.handleLocationIdChange(item.id, e.target.value)}
                                                                onKeyDown={(e) => this.handleLocationIdSubmit(item, e)}
                                                                className="form-control"
                                                                placeholder={`ID de ${item.location_type === "ANTENNA" ? "Antena" : "Contrato"}`}
                                                            />
                                                        ) : (
                                                            <span onClick={() => this.handleLocationIdChange(item.id, item.location_id || "")}>
                                                                {item.location_id || "Click para editar"}
                                                            </span>
                                                        )
                                                    ) : (
                                                        item.location_id || "-"
                                                    )}
                                                </td>
                                                <td>{item.created_by_name}</td>
                                                <td>
                                                    {formatRelative(new Date(item.created_date), new Date(), { locale: es })}
                                                </td>
                                                <td>
                                                    {formatRelative(new Date(item.update_date), new Date(), { locale: es })}
                                                </td>
                                                <td>
                                                    <button
                                                        onClick={() => this.deleteItem(item.id)}
                                                        className="btn btn-danger btn-sm"
                                                    >
                                                        <i className="material-icons">delete</i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}